<section class="guidelines" id="guidelines">
    <div class="guidelines__title">
      <h1>Product Guidelines</h1>
    </div>

    <div class="guidelines__list">
      <div class="guidelines__list__item">
        <div class="guidelines__list__item__title">
          <h1>
            Brief
          </h1>
        </div>
        <div class="guidelines__list__item__content">
          <div data-aos="zoom-out-up" data-aos-duration="1000" class="text">
              <p>{{guideline.guidelineText}}</p>
            </div>

        </div>
      </div>
      <app-button classList="btn rounded bordered bg-white" text="Download Full Paper" [href]="guideline.guidelineUrl"></app-button>
      <!-- <div class="guidelines__list__item">
        <div class="guidelines__list__item__title">
          <h1>

          </h1>
        </div>
        <div class="guidelines__list__item__content">
            <div data-aos="zoom-out-down" class="image">
               <a target="_blank" [href]="guideline.guidelineUrl"> <img src="../../../assets/PDF@2x.png" alt=""></a>
            </div>
        </div>
      </div> -->
    </div>
    <span class="down-ref">(05)</span>
  </section>
